// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3yFl0","requiredAsterisk":"Info_requiredAsterisk__27nJ7"};